<div class="bg-light  d-flex flex-row align-items-center">
  <c-container>

    <div class="btn-group pull-right">
      <button class="btn btn-white" type="button" [ngClass]="{'active': selectedView === 'calendar'}"
        (click)="selectView('calendar')">
        <mat-icon>calendar_view_day</mat-icon>
      </button>
      <button class="btn btn-white" type="button" [ngClass]="{'active': selectedView === 'list'}"
        (click)="selectView('list')">
        <mat-icon>list</mat-icon>
      </button>
    </div>

    <br>
    <mat-toolbar class="primary">
      <mat-toolbar-row>
        <label>View by</label>
        <mat-radio-group (change)="typeChange($any($event))" [value]="view_type" aria-label="View By">
          <mat-radio-button class="radio-button" value="all">All</mat-radio-button>
          <mat-radio-button class="radio-button" value="faculty">Faculty</mat-radio-button>
          <mat-radio-button class="radio-button" value="course">Course</mat-radio-button>
          <mat-radio-button class="radio-button" value="room">Room</mat-radio-button>
        </mat-radio-group>
        <span class="title-spacer"></span>

        <ng-multiselect-dropdown *ngIf="view_type=='faculty'" style="width:25%;font-size: 14px;"
          (onSelect)="onViewChange($event)" (selectionChange)="onViewChange($event)" [placeholder]="'Select Faculty'"
          [settings]="facultyDropdownSettings" [data]="faculties">
        </ng-multiselect-dropdown>

        <ng-multiselect-dropdown *ngIf="view_type=='room'" style="width:25%;font-size: 14px;"
          (onSelect)="onViewChange($event)" [placeholder]="'Select Room'" [settings]="roomDropdownSettings"
          [data]="rooms">
        </ng-multiselect-dropdown>

        <ng-multiselect-dropdown *ngIf="view_type=='course'" style="width:25%;font-size: 14px;"
          (onSelect)="onViewChange($event)" [placeholder]="'Select Course'" [settings]="courseDropdownSettings"
          [data]="courses">
        </ng-multiselect-dropdown>

        <!-- <button mat-raised-button color="primary" (click)="download()" style="font-size: 14px;">
          Download
        </button> -->
      </mat-toolbar-row>
    </mat-toolbar>

    <br>

    <calendar-header (viewChange)="onViewTypeChange($any($event))" (viewDateChange)="onDateChange($any($event))"
      [(view)]="view" [(viewDate)]="viewDate">
    </calendar-header>

    <div *ngIf="selectedView=='calendar'" [ngSwitch]="view">
      <mwl-calendar-month-view *ngSwitchCase="'month'" [activeDayIsOpen]="activeDayIsOpen"
        (dayClicked)="dayClicked($event.day)" [viewDate]="viewDate" [events]="events">
      </mwl-calendar-month-view>

      <mwl-calendar-week-view *ngSwitchCase="'week'" [dayStartHour]="08" [viewDate]="viewDate" [events]="events">
      </mwl-calendar-week-view>

      <mwl-calendar-day-view *ngSwitchCase="'day'" [dayStartHour]="08" [viewDate]="viewDate" [events]="events">
      </mwl-calendar-day-view>
    </div>

    <div *ngIf="selectedView=='list'">
      <mat-card class='light'>
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Room Booking List </mat-header-cell>
            <mat-cell *matCellDef="let customer"><span [innerHTML]="customer.title"></span></mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <div class="no-data-message" *ngIf="dataSource.length === 0" class="no-data-message">
          No data to show.
        </div>
      </mat-card>
    </div>
  </c-container>
</div>